export default __webpack_public_path__ + "assets/img/process_loader-2.83cda1c8.gif";